import React, {useContext} from 'react';
import {useIntl} from 'react-intl';
import {ModalContext, ThemeContext} from '../../apiContexts';
import {ButtomStyled} from '../../styles';
import ModalEnum from '../modals/modalEnum';

const SelectDeviceButton = () => {
    const intl = useIntl();
    const theme = useContext(ThemeContext);
    const {openModal} = useContext(ModalContext);

    return (
        <ButtomStyled
            theme={theme}
            outline
            className="custom-shadow custom-border btn-theme mb-3"
            onClick={() => openModal(ModalEnum.NEW_REPORT)}
        >
            <span>{intl.formatMessage({id: 'selectDevice'})}</span>
        </ButtomStyled>
    );
};

export default SelectDeviceButton;
